'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateToHTML = require('./stateToHTML');

Object.defineProperty(exports, 'stateToHTML', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateToHTML).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-export-html/lib/main.js
// module id = 54
// module chunks = 1 2